import React from 'react';
interface CardProps {
  children: React.ReactNode;
  title?: string;
  className?: string;
}
export function Card({
  children,
  title,
  className = ''
}: CardProps) {
  return <div className={`bg-white overflow-hidden shadow-sm rounded-xl border border-gray-100 ${className}`} data-id="element-1500">
      {title && <div className="px-5 py-4 border-b border-gray-100" data-id="element-1501">
          <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-1502">
            {title}
          </h3>
        </div>}
      <div className="px-5 py-5" data-id="element-1503">{children}</div>
    </div>;
}